import React, { useContext, useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import PersonAdd from '@material-ui/icons/PersonAdd'
import CircularProgress from '@material-ui/core/CircularProgress'
import { cloneCampaign } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import { ErrorMessage } from '../../../../../components/error-message'

const OuterWrapper = styled.div`
  margin-left: 32px;
  @media(max-width: 1200px) {
    margin-left: 0px;
    padding-bottom: 116px;
    width: 100%;
  }
`

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 540px;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;
  &:hover {
    background: #EFEFEF;
  }
  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`

const ImportButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`

const ImportCampaign = (props) => {
  const { user, updateUser } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext)
  const [loading, updateLoading] = useState(false)
  const [name, updateName] = useState('')
  const [campaignId, updateCampaignId] = useState('')
  const [nameError, updateNameError] = useState(false)
  const [campaignIdError, updateCampaignIdError] = useState(false)
  const [error, updateError] = useState('')

  const handleClear = () => {
    updateName('')
    updateCampaignId('')
    updateNameError(false)
    updateCampaignIdError(false)
    updateError('')
  }

  const handleImport = () => {
    if (name === '') {
      updateError('Please enter a name for the campaign.')
      updateNameError(true)
    } else {
      const lcName = name.toLowerCase()
      let duplicate = false
      for (let n = 0; n < props.campaigns.length; ++n) {
        if (props.campaigns[n].name.toLowerCase() === lcName) {
          duplicate = true
          break
        }
      }
      if (duplicate) {
        updateError('There is already a campaign with that name.')
        updateNameError(true)
      } else if (campaignId === '') {
        updateError('Please enter the ID of the campaign to be imported.')
        updateCampaignIdError(true)
      } else if (!(/^[0-9]+$/.test(campaignId))) {
        updateError('The ID of the campaign to be imported must be a whole number.')
        updateCampaignIdError(true)
      } else {
        const campaignIdNum = parseInt(campaignId)
        if (campaignIdNum === 0) {
          updateError('The ID of the campaign to be imported must be greater than 0.')
          updateCampaignIdError(true)
        } else {
          updateLoading(true)
          cloneCampaign(user.id, campaignIdNum, name).then((res) => {
            if (res.data.id) {
              openSnackbar('Campaign successfully imported.', false)
              props.history.push('/dashboard/campaign/' + res.data.id)
            } else {
              updateLoading(false)
              updateError('The specified campaign ID is invalid.')
              updateCampaignIdError(true)
            }
          })
        }
      }
    }
  }

  return props.campaignsState !== 2 && !loading ? (
    <OuterWrapper>
      <Container className={props.className}>
        <CircularProgress size={32} />
      </Container>
    </OuterWrapper>
  ) : (
    <OuterWrapper>
      <Container className={props.className}>
        <HeaderContainer>
          <Label>
            <PersonAdd /> Import a Campaign
          </Label>
        </HeaderContainer>

        <div style={{fontSize: '16px', fontStyle: 'italic', color: '0x676767', marginBottom: '20px'}}>Use this to make a copy of a campaign built by someone else.</div>

        <Input
          error={nameError}
          label="Name (for your copy of the campaign)"
          value={name}
          onChange={updateName}
        />

        <Input
          error={campaignIdError}
          label="From Campaign ID (ask the campaign builder for this)"
          value={campaignId}
          onChange={updateCampaignId}
        />

        {error !== '' && 
          <ErrorMessage>
            {error}
          </ErrorMessage>
        }
        <ButtonContainer>
          <ClearButton
            label="Clear"
            onClick={handleClear}
          />
          <ImportButton 
            label="Import Campaign"
            isLoading={loading}
            onClick={handleImport}
          />
        </ButtonContainer>
      </Container>
    </OuterWrapper>
  )
}

export default withRouter(ImportCampaign)